import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M3.675 5.175C3.85 4.825 4.2 4.6 4.6 4.6L15.4 4.6C15.775 4.6 16.125 4.825 16.3 5.175C16.45 5.525 16.4 5.95 16.15 6.25L11.6 11.825V15C11.6 15.325 11.425 15.6 11.15 15.725C10.875 15.85 10.55 15.825 10.3 15.65L8.7 14.45C8.5 14.3 8.4 14.075 8.4 13.8V11.825L3.825 6.25C3.575 5.95 3.525 5.525 3.675 5.175Z"
	})
});
const ForwardRef = forwardRef(SvgSortFilled);
export default ForwardRef;
